import { http } from "@/libs/util";
import util from "@/libs/util";
const {
  query_asset,
  asset_inventory_detail,
  asset_inventory_create,
  asset_base_data,
  asset_inventory_check_asset,
  asset_inventory_add_irregular_asset,
  asset_inventory_list,
  asset_inventory_remove_irregular_asset,
  asset_inventory_delete,
  asset_inventory_topic_list,
  asset_inventory_topic_save,
  asset_inventory_batch_pass_checked,
} = util.api || {};

export function queryAssetApi(params) {
  return http.get(query_asset, params);
}

export function createAssetInventoryApi(params) {
  return http.post(asset_inventory_create, params);
}

export function getAssetInventoryDetailApi(params) {
  return http.get(asset_inventory_detail, params);
}

export function getAssetBaseData(params) {
  return http.get(asset_base_data, params);
}

export function assetInventoryCheckAssetApi(params) {
  return http.post(asset_inventory_check_asset, params);
}

export function assetInventoryAddIrregularAssetApi(params) {
  return http.post(asset_inventory_add_irregular_asset, params);
}

export function assetInventoryListApi(params) {
  return http.get(asset_inventory_list, params);
}

// 删除设备
export function assetInventoryRemoveIrregularAssetApi(params) {
  return http.post(asset_inventory_remove_irregular_asset, params);
}

// 废弃盘点流程
export function assetInventoryDeleteApi(params) {
  return http.post(asset_inventory_delete, params);
}

// 获取批次
export function getAssetInventoryTopicListApi(params) {
  return http.get(asset_inventory_topic_list, params);
}

export function setAssetInventoryTopicSaveApi(params) {
  return http.post(asset_inventory_topic_save, params);
}

export function inventoryBatchPassApi(params) {
  return http.post(asset_inventory_batch_pass_checked, params);
}
